/**
 * Features Orange doesn't offer (yet) in Ghana. The code and routes stay in place;
 * this only hides their entry points in the UI. Remove a prefix to bring it back.
 */
/** Record Exchange lives under Settings instead (/settings/record-exchange). */
/** US insurance claims stay hidden; patient billing (bills, payments, books) is shown. */
/** US integrations (clearinghouse claims, Stripe, WENO ePrescribing, HIE trading partners) are hidden too. */
/**
 * PRP (Maryland's Psychiatric Rehabilitation Program, a US Medicaid service)
 * is off for Ghana. Every PRP gate (the "prp" permission, PRP staff roles,
 * the PRP Programs plan) reads this, so flipping it brings the module back.
 */
export const PRP_ENABLED = false;

export const HIDDEN_PATH_PREFIXES = [
  ...(PRP_ENABLED ? [] : ["/prp", "/settings/prp", "/signup/prp"]),
  "/billing/claims",
  "/prescriptions",
  "/record-exchange",
  "/account/eprescribing",
  "/settings/integrations/claimrev",
  "/settings/integrations/stripe",
  "/settings/integrations/eprescribing",
  "/settings/integrations/exchange-partners",
];

/** RBAC roles not offered while their feature is hidden. */
export function isHiddenRole(name: string): boolean {
  return !PRP_ENABLED && name.startsWith("prp_");
}

/** Patient-chart tab paths (relative to /patients/:id) hidden for the same reason. */
export const HIDDEN_CHART_TABS = ["prescriptions", "new-rx", "devices"] as const;

export function isHiddenHref(href: string): boolean {
  const path = href.split(/[?#]/)[0] ?? href;
  return HIDDEN_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function isHiddenChartTab(path: string): boolean {
  return (HIDDEN_CHART_TABS as readonly string[]).includes(path);
}
